import React from "react";
import { Switch, SwitchProps } from "@mui/material";

export default function AlignedSwitch(props: SwitchProps): React.JSX.Element {
  return <Switch 
    {...props}
    sx={{
      "& .MuiButtonBase-root": {
        "& .PrivateSwitchBase-input.MuiSwitch-input": {
          left: 0,
          width: "150%"
        }
      },
      "& .Mui-checked": {
        "& .PrivateSwitchBase-input.MuiSwitch-input": {
          left: "-50%",
          width: "150%"
        }
      }
    }}
  />
}